import React from 'react';

import { AuthUserContext } from '../Session';

import { withFirebase } from '../Firebase';

const withAuthentication = Component => {
  class WithAuthentication extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          authUser: null,
        };
    }
  
    componentDidMount() {
      this.listener = this.props.firebase.auth.onAuthStateChanged(
        authUser => {
          //console.log("authUser listener = "+authUser)
          this.setState( {
            authUser: authUser,
          });
        }
      );
    }

    componentWillUnmount() {
      //console.log("release authUser listener ")
      this.listener();
    }

    render() {
      //console.log("AuthUserContext.Provider = "+this.state.authUser)
      return (
        <AuthUserContext.Provider value={this.state.authUser}>
            <Component  authUser={this.state.authUser} {...this.props} />
        </AuthUserContext.Provider>
      );
    }
  }

  return withFirebase(WithAuthentication);
};

export default withAuthentication;